import React, { useEffect, useState } from 'react';

import {
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Button,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText
} from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from '../../../components/Pagination';
import SpyService from '../service';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ReactLoader from 'components/Loader';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import RingGroupsService from 'services/ServiceRINGGROUPS';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';

const InternalRouteList = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const [internalRoutes, setInternalRoutes] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [seachSpy, setSeachSpy] = useState();
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [ringGroups, setRingGroups] = useState([]);

  useEffect(() => {
    getRoute();
    handleGetRingGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRoute = (selectedPage = 1) => {
    SpyService.getAll(selectedPage, 10)
      .then((res) => {
        const { data, totalRegisters } = res.data;
        const newActivePage = selectedPage || activePage;

        setInternalRoutes(data);
        setQuantity(totalRegisters);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possivel os grupos de rota de saída', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handleGetRingGroups = () => {
    RingGroupsService.getAll()
      .then((response) => {
        setRingGroups(response.data.data);
      })
      .catch(() => {
        console.log('Error getting ring groups');
      });
  };

  const getRingGroupName = (ringGroupId) => {
    const ringGroup = ringGroups.find((rg) => rg.id === ringGroupId);
    return ringGroup ? ringGroup.name : `Ring Group ID: ${ringGroupId}`;
  };

  const handlePageChange = (activePage) => {
    getRoute(activePage);
  };

  function getGroupSeach(event, selectedPage = 1) {
    const term = event.target.value;
    setSeachSpy(term);

    if (term.trim() !== '') {
      SpyService.getAllSeach(selectedPage, 10, term, false)
        .then((res) => {
          const { data, totalRegisters } = res.data;
          const newActivePage = selectedPage || activePage;

          setInternalRoutes(data);
          setQuantity(totalRegisters);
          setActivePage(newActivePage);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Não foi possivel listar os espiões', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      getRoute(selectedPage);
    }
  }

  function deleteGroup(id) {
    SpyService.delete(id)
      .then(() => {
        toast.success('Rota interna excluida com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        getRoute();
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getRoute();
      });
  }

  const controlDelete = (id) => {
    setidResource(id);
    setOpenModalConfirmation(true);
  };

  function handleUpdate(id) {
    history.push(`internalRoute/form/${id}`);
  }

  return (
    <>
      <SimpleHeader
        setCreate="/admin/internalRoute/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Rota Interna</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="11">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Buscar por rota"
                          type="text"
                          onChange={(event) => getGroupSeach(event)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={internalRoutes}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'route',
                      text: 'Rota',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },

                    {
                      dataField: 'type',
                      text: 'Tipo',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (_, row) => {
                        if (row.type === 'EXTENSION') return 'Ramal';
                        if (row.type === 'SPECIFIC_EXTENSION')
                          return 'Ramal Específico';
                        if (row.type === 'IVR') return 'URA';
                        if (row.type === 'QUEUE') return 'Fila';
                        if (row.type === 'RING_GROUP') return 'Grupo de Toque';
                        if (row.type === 'CONFERENCE') return 'Conferência';
                        if (row.type === 'CUSTOMIZED') return 'Customizado';
                      }
                    },
                    {
                      dataField: 'data',
                      text: 'Tipo de Entrada',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (_, row) => {
                        if (row.type === 'SPECIFIC_EXTENSION')
                          return row.specific_extension_id;
                        if (row.type === 'IVR') return row.ivr?.name || '';
                        if (row.type === 'QUEUE') return row.queue?.name || '';
                        if (row.type === 'RING_GROUP') {
                          // Use the ring group object if available, otherwise use the helper function
                          return (
                            row.ring_group?.name ||
                            getRingGroupName(row.ring_group_id)
                          );
                        }
                        return '';
                      }
                    },

                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            onClick={() => handleUpdate(row.id)}
                            size="sm"
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },

                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            onClick={() => controlDelete(row.id)}
                            size="sm"
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteGroup}
        message={'Tem certeza que deseja excluir a rota de entrada?'}
      />
    </>
  );
};

export default InternalRouteList;
